import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { FilterOperation } from "src/app/models/custom-table/custom-table.model";
import { AppState } from "src/app/store/reducers";
import { GridUtils } from "../../utils/gridUtils";
import {
  setAdvancedFilterQuery,
  setSimpleFilterQuery,
} from "../../utils/tableUtils";
import { AppSessionService } from "../app-session/app-session.service";

const EMPTY_STRING = "";
const NULL_VALUE = null;

@Injectable({
  providedIn: "root",
})
export class FuelStocksService {
  private BASE_URL = this.appSession.baseUrl + "/api/v1/inventories";

  constructor(
    private http: HttpClient,
    private store: Store<AppState>,
    private appSession: AppSessionService
  ) {}

  public getFuelStocks(
    paging?: any,
    filteringArgs?: any,
    sortingArgs?: any,
    advancedFilteringArgs?: any
  ): Observable<any> {
    let headers = new HttpHeaders({
      "Content-type": "application/json",
    });

    let filterQuery = EMPTY_STRING;
    let advancedFilterQuery = EMPTY_STRING;
    let orderQuery = EMPTY_STRING;

    if (filteringArgs) {
      filterQuery = setSimpleFilterQuery(filteringArgs);
    }

    if (advancedFilteringArgs) {
      advancedFilterQuery = setAdvancedFilterQuery(advancedFilteringArgs);
    }

    if (sortingArgs) {
      const { active, direction } = sortingArgs;
      orderQuery += active + "," + direction.toUpperCase();
    }

    if (filterQuery.length > 0 || advancedFilterQuery.length > 0) {
      headers = headers.append(
        "query",
        `${filterQuery} ${
          filterQuery.length > 0 && advancedFilterQuery.length > 0
            ? FilterOperation.AND
            : ""
        } ${advancedFilterQuery}`
      );
    }

    if (orderQuery.length > 0) {
      headers = headers.append("sort", orderQuery);
    }

    return this.http.get(
      this.buildDataUrl(
        paging,
        filteringArgs,
        sortingArgs,
        headers,
        "/search?"
      ),
      { headers }
    );
  }

  updateFuelStock(action): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });

    const data = JSON.stringify(action.fuelStock);
    const url = `${this.appSession.baseUrl + "/api/v1/inventories"}/${
      action.fuelStock.code
    }`;

    return this.http.put(url, data, { headers });
  }

  getFuelStock(action): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });
    // const username = localStorage.getItem('username');
    const url = `${this.appSession.baseUrl + "/api/v1/inventories"}/stocks/${
      action.fuelStock
    }`;

    return this.http.get(url, { headers });
  }

  getMovements(action): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });
    // const username = localStorage.getItem('username');
    const url = `${this.appSession.baseUrl + "/api/v1/inventories"}/movements/${
      action.code
    }`;

    return this.http.get(url, { headers });
  }

  createFuelStock(action): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });

    const data = JSON.stringify(action.fuelStock);
    const url = `${this.appSession.baseUrl + "/api/v1/inventories"}`;

    return this.http.post(url, data, { headers });
  }

  // Grid filter helpers block

  private buildDataUrl(
    pagingArgs: any,
    filteringArgs: any,
    sortingArgs: any,
    header: HttpHeaders,
    path: string
  ): string {
    // let baseQueryString = `${DATA_URL}?$count=true`;
    let baseQueryString = `${
      this.appSession.baseUrl + "/api/v1/inventories"
    }${path}`; // `${this.BASE_URL}/customers/search?`;
    let scrollingQuery = EMPTY_STRING;

    let query = EMPTY_STRING;

    if (pagingArgs) {
      scrollingQuery = GridUtils._buildScrollExpression(pagingArgs);
    }

    // query += (orderQuery !== EMPTY_STRING) ? `&${orderQuery}` : EMPTY_STRING;
    // query += (filterQuery !== EMPTY_STRING) ? `&${filterQuery}` : EMPTY_STRING;
    query +=
      scrollingQuery !== EMPTY_STRING ? `&${scrollingQuery}` : EMPTY_STRING;

    baseQueryString += query;

    return baseQueryString;
  }

  getInventoryStats(action): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });
    const url = `${this.appSession.baseUrl + "/api/v1/inventories/"}${
      action.code
    }/stats`;

    return this.http.get(url, { headers });
  }
}
